module.exports = __webpack_public_path__ + "static/media/5DPO8.06d93d14.jpg";